<template>
  <div id="index" @keydown="keydown()">
    <el-container>
      <el-main>
        <el-row :gutter="24" style="margin: 0px !important">
          <el-col :xs="0" :sm="0" :md="12" :lg="12">
            <img
              v-if="brand == 'IR'"
              src="~assets/img/Loginlogo.png"
              class="loginIcon"
            />
            <img
              v-if="brand == 'GD'"
              src="~assets/img/GDlogo.png"
              class="loginIcon"
            />
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <!-- <div class="login-box" style="margin: 10% auto 0 auto;"> -->
            <div class="login-box" >
              <h3 class="login-title">
                <img v-if="brand == 'IR'" src="~assets/img/logoBox.png" />
                <img v-if="brand == 'GD'" src="~assets/img/logoBox_GD.png" />
                <br />
                {{ $t("title.title") }}
              </h3>
              <el-form
                ref="loginForm"
                :model="form"
                label-width="0px"
                class="login-input"
              >
                <el-form-item prop="userNameOrEmailAddress">
                  <el-input
                    type="text"
                    placeholder="Username"
                    v-model="form.userNameOrEmailAddress"
                     
                  >
                  <img slot="prefix" src="~assets/img/btnIcon/profile_circled.png"></img>
                  </el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input
                    type="password"
                    placeholder="Password"
                    v-model="form.password"
                    show-password 
                  >                  
                  <img slot="prefix" src="~assets/img/btnIcon/lock.png"></img>
                  </el-input>
                </el-form-item>
                <el-button
                  type="primary"
                  class="lopginbtn"
                  @click="login"
                  style="margin-top: 16px"
                  >{{ $t("button.login") }}
                </el-button>
              </el-form>
              <div style="margin-top: 24px; margin-left: 10px">
                <!-- <a  @click="forgetPws()"
                                      class="fl"
                                      style="color: rgb(142, 144, 147);cursor:pointer"
                                      >忘记密码？</a
                                    > -->
                <div class="fl Language_div">
                  <a @click="changeLanguage('en')">English </a> |
                  <a @click="changeLanguage('zh')"> 中文简体</a>
                  <br /> <br />
            
                </div>

                  <div class="fr Language_div">
                  <a @click="forgetPws()">{{ $t("title.forgetPwd") }} </a>  
                  
                  <a @click="getSamlRequestUrl()" style="margin-left:5px;">{{ $t("title.ssologin") }}  </a>  
                </div>
                <div class="clear"></div>
              </div>
              
            </div> 
             <!-- <el-button type="default" plain icon="el-icon-position" style="margin: 12px auto;display:block; background-color: rgba(130, 131, 147, 0.5);   width: 365px;color:#fff">访问中国站点</el-button> -->
          </el-col>
        </el-row>
        <div class="loginRecordBox">
          <el-link href="https://www.irconnectivity.com" target="_blank"
            >备案主体：英格索兰（中国）投资有限公司</el-link
          >
          <el-link href="https://www.beian.miit.gov.cn" target="_blank"
            >备案号：沪ICP备05062828号-5</el-link
          >
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
            target="_blank"
            ><img
              src="~assets/img/recordicon.png"
              style="float: left; width: 16px"
            />沪公网安备 31010502005741号
          </el-link>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {
  authenticate,
  GetUserMenu,
  getUserBrand,
  getSamlRequestUrl,
} from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
import router from "../../../src/router/index";
import defaultSettings from "@/config/defaultSettings";

export default {
  name: "Index",
  data() {
    return {
      // 对话框显示和隐藏
      dialogVisible: false,
      form: {
        userNameOrEmailAddress: "",
        password: "",
        clientName: this.$route.path,
      },
      brand: "",
    };
  },
  created: function () {
    var that = this;
    let brandCode = localStorage.getItem("user_brand")
      ? localStorage.getItem("user_brand")
      : "IR";
    that.brand = brandCode;
    var lastLoginName = getCookie("userName");
    if (
      lastLoginName != undefined &&
      lastLoginName != null &&
      lastLoginName != "undefined"
    )
      that.form.userNameOrEmailAddress = lastLoginName;
  },
  computed: {
    ...mapGetters({
      menuListStore: "menuListState",
      authOperationStore: "authOperationState",
    }),
  },
  methods: {
    ...mapMutations([
      "setLanguage",
      "setMenuListState",
      "setAuthOperationState",
    ]),
    changeLanguage(e) {
      window.localStorage.setItem("user_lang", e);
      this.setLanguage(e);
      window.location.reload();
    },
    async login() {
      this.submitForm("form");
    },
    keydown(e) {
      var theEvent = e || window.event;
      var code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        this.login();
      }
    },
    getSamlRequestUrl() {
      window.location.href = "/ssologin";
      // getSamlRequestUrl().then((res) => {
      //   window.location.href = samlUrl;
      // });
    },
    async submitForm(formName) {
      var that = this;
      that.form.userNameOrEmailAddress =
        that.form.userNameOrEmailAddress.trim();
      that.form.password = that.form.password.trim();
      if (that.form.userNameOrEmailAddress == "" || that.form.password == "") {
        that.$message({
          showClose: true,
          message: that.$t("tips.validate"),
          type: "error",
        });
      } else {
        try {
          let res = await authenticate(that.form);
          // const jse = new this.$jsEncrypt(); // 实例化一个 jsEncrypt 对象
          // jse.setPublicKey(Globals.RSAWebPublicKey); //配置公钥
          // var req = JSON.parse(JSON.stringify(that.form));
          // var rsaEnCrypt = jse.encrypt(req.password); //加密密码
          // req.password = rsaEnCrypt;
          // let res = await authenticate(req);
          if (res.success === true) {
            setItemToLocalstorage("userName", res.result.userName);
            setCookie("userName", res.result.userName, 1);
            setCookie("userSessionID", res.result.sessionId, 1); //存储sessionID
            setItemToLocalstorage("userInfo", res.result.userId); //存储用户信息
            setItemToLocalstorage("accountType", res.result.accountType); //存储账号类型
            setItemToLocalstorage("auth", res.result.accessToken);
            setItemToLocalstorage("roles", res.result.roles);
            localStorage.setItem("isRefresh", res.result.isRefresh);
            let userBrand = await this.getCurUserBrand();

            if(res.result.accountType == "emcCustomer") {
              localStorage.setItem("emcStationProject", res.result.emcStationProject);
              const targetUrl = `/OneStationMonitor?id=${res.result.emcStationProject}`
              // &name=${row.projectName}&nameEn=${row.projectNameEn}&img=${row.stationImgUrl};
              window.location.href = targetUrl;
            }
            if (
              userBrand &&
              userBrand.indexOf(localStorage.getItem("user_brand")) == -1
            ) {
              localStorage.setItem("user_brand", userBrand.split(",")[0]);
            }
            localStorage.setItem("isneedchange", res.result.isNeedChangePass);
            if (
              res.result.verifyId != undefined &&
              res.result.verifyId != null &&
              res.result.verifyId != ""
            ) {
              setCookie("vid", res.result.verifyId, 1);
            }
            that.getUserMenu();
          }
        } catch (err) {
          if (err != undefined) {
            var msg = err.error.message.replace("[", "").replace("]", "");
            that.$message({
              showClose: true,
              message: that.$t("loginTips." + msg),
              type: "error",
            });
          }
        }
      }
    },
    urlencode(str) {
      str = (str + "").toString();
      //encodeURIComponent() 函数可把字符串作为 URI 组件进行编码。
      //该方法不会对 ASCII 字母和数字进行编码，也不会对这些 ASCII 标点符号进行编码： - _ . ! ~ * ' ( ) 。
      return encodeURIComponent(str)
        .replace(/!/g, "%21")
        .replace(/'/g, "%27")
        .replace(/\(/g, "%28")
        .replace(/\)/g, "%29")
        .replace(/\*/g, "%2A")
        .replace(/%20/g, "+");
    },
    async getCurUserBrand() {
      let that = this;
      let res = await getUserBrand();
      return res.result;
    },
    async getUserMenu() {
      var that = this;
      await GetUserMenu()
        .then(
          (res) => {
            if (res.success === true) {
              var menuList = res.result;
              var isHasDefault = false;
              var firstPage = "/";
              var isEmptyMenu = false;
              if (menuList == null || menuList.length == 0) {
                isEmptyMenu = true;
              } else {
                //缓存用户操作权限
                var authOperations = [];
                menuList.forEach(function (obj, index) {
                  obj.operations.forEach((op1) => {
                    authOperations.push(op1);
                  });
                  if (obj.children.length > 0) {
                    obj.children.forEach(function (o, i) {
                      o.operations.forEach((op2) => {
                        authOperations.push(op2);
                      });
                    });
                  }
                });

                // that.setMenuListState(menuList);
                // that.setAuthOperationState(authOperations);
                menuList = menuList.filter((a) => a.code != "MultiBrand_View" && a.code != "EmcStationMonitorScreen_View");
                setItemToLocalstorage("menuData", menuList);
                setItemToLocalstorage("authOperations", authOperations);

                menuList.forEach(function (obj, index) {
                  if (obj.children.length == 0) {
                    isEmptyMenu = true;
                  } else {
                    isEmptyMenu = false;
                  }
                });
              }

              if (isEmptyMenu) {
                that.$message({
                  showClose: true,
                  message: that.$t("tips.noPerimission"),
                  type: "error",
                });
              } else {
                menuList.forEach(function (obj) {
                  if (obj.url == "/index") isHasDefault = true;
                });
                if (isHasDefault) {
                  //window.location.href = "/index";
                  window.location.href = "/welcome";
                  // this.$router.push("/default")
                } else {
                  menuList.forEach(function (obj, index) {
                    if (index == 0) {
                      if (obj.children.length > 0) {
                        obj.children.forEach(function (o, i) {
                          if (i == 0) firstPage = o.url;
                        });
                      }
                    }
                  });
                  //window.location.href = firstPage;
                  window.location.href = "/welcome";
                  // this.$router.push("/")
                }
              }
            } else {
              that.$message({
                showClose: true,
                message: "error",
                type: "error",
              });
            }
          },
          (err) => {
            if (err.error.code != 401) {
              that.$message.error(err.error.message);
            }
          }
        )
        .catch((err) => {
          if (err.error.code != 401) {
            that.$message.error(err.error.message);
          }
        });
    },
    forgetPws() {
      this.$router.push("/ResetPassword");
    },
  },
};
</script>

<style lang='less' scope>
.el-button--primary:focus,
.el-button--primary:hover {
  background: #d52b1e;
  border-color: #603a3a;
  color: #fff;
}
</style>
<style lang='less'>
.theme1 {
  .el-main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url("~assets/img/login.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 0 !important;
    width: 100%;
  }

  .el-main {
    padding: 20px 7%;
  }

  .login-box .el-input__inner {
    height: 48px;
    background: #f7f7f8;
    border-radius: 30px;
    border: 1px solid #cbcdd3;
    font-size: 14px;
    color: #1f2128;
  }
  .login-box {
    el-form .el-form-item {
      margin-top: 16px;
    }
    .el-input__icon {
      font-size: 20px;
      color: #5e6166;
    }
    .el-input__prefix {
      left: 10px;
      top: 2px;
    }
    .el-input__suffix {
      top: 2px;
      right: 10px;
    }
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus,
  .el-select .el-input.is-focus .el-input__inner,
  .el-select .el-input__inner:focus {
    border-color: #603a3a !important;
  }
  .loginRecordBox {
    margin-left: 0;
  }
  @media (min-width: 992px) {
    .el-col-sm-0 {
      display: block;
    }
    .el-col-xs-0 {
      display: block;
    }
  }
}
</style>
